import { render, staticRenderFns } from "./PlannedTransactionViewDefault.vue?vue&type=template&id=2b602aba&scoped=true&"
import script from "./PlannedTransactionViewDefault.vue?vue&type=script&lang=js&"
export * from "./PlannedTransactionViewDefault.vue?vue&type=script&lang=js&"
import style0 from "./PlannedTransactionViewDefault.vue?vue&type=style&index=0&id=2b602aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b602aba",
  null
  
)

export default component.exports